import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Sparkles, Check } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function UpgradeModal({ open, onOpenChange, reason }) {
  const nav = useNavigate();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="glass-strong border-white/[0.1]" data-testid="upgrade-modal">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <Sparkles className="text-indigo-400" size={20}/>
            <DialogTitle>Upgrade to unlock more</DialogTitle>
          </div>
          <DialogDescription>{reason || "You've reached your free plan limit."}</DialogDescription>
        </DialogHeader>
        <div className="grid sm:grid-cols-2 gap-4 py-2">
          <div className="glass rounded-xl p-4">
            <div className="text-xs uppercase tracking-widest text-zinc-400">Pro</div>
            <div className="text-2xl font-bold mt-1">$9.99<span className="text-sm text-zinc-500">/mo</span></div>
            <ul className="mt-3 space-y-1.5 text-sm">
              <li className="flex gap-2"><Check size={14} className="text-emerald-400 mt-0.5"/>10,000 words / doc</li>
              <li className="flex gap-2"><Check size={14} className="text-emerald-400 mt-0.5"/>Unlimited rounds</li>
              <li className="flex gap-2"><Check size={14} className="text-emerald-400 mt-0.5"/>No watermark</li>
            </ul>
          </div>
          <div className="rounded-xl p-4 bg-gradient-to-br from-indigo-600/20 to-purple-600/20 border border-indigo-500/30">
            <div className="text-xs uppercase tracking-widest text-indigo-300">Business</div>
            <div className="text-2xl font-bold mt-1">$24.99<span className="text-sm text-zinc-500">/mo</span></div>
            <ul className="mt-3 space-y-1.5 text-sm">
              <li className="flex gap-2"><Check size={14} className="text-emerald-400 mt-0.5"/>50,000 words / doc</li>
              <li className="flex gap-2"><Check size={14} className="text-emerald-400 mt-0.5"/>Batch upload (10)</li>
              <li className="flex gap-2"><Check size={14} className="text-emerald-400 mt-0.5"/>API + analytics</li>
            </ul>
          </div>
        </div>
        <Button onClick={() => { onOpenChange(false); nav("/pricing"); }} className="bg-indigo-600 hover:bg-indigo-700 glow-primary" data-testid="upgrade-now-btn">
          Upgrade now
        </Button>
      </DialogContent>
    </Dialog>
  );
}
